import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import type { AuthUser } from '../types/auth-user'

type State = {
  token?: string
  user?: AuthUser
  nivelAcesso?: number
  versionUrl?: string
  versionApp?: string
	metaPorQuantidade?: boolean
  chaveMaps?: string
  actions?: {
		setMetaPorQuantidade: (metaPorQuantidade: boolean) => void
    setToken: (token: string | undefined) => void
    setUser: (user: AuthUser) => void
    setVersionUrl: (versionUrl: string) => void
    clearAll: () => void
    setVersionApp: (versionApp: string) => void
    setChaveMaps: (chaveMaps: string) => void
    setNivelAcesso: (nivelAcesso?: number | null) => void
  }
}

export const useAuthStore = create(
  persist<State>(
    (set) => ({
      user: undefined,
      token: undefined,
      versionUrl: undefined,
      versionApp: undefined,
      chaveMaps: undefined,
			metaPorQuantidade: false,
			nivelAcesso: 1,
      actions: {
        setChaveMaps: (chaveMaps) => set({ chaveMaps }),
        setToken: (token) => set({ token }),
        setUser: (user) => set({ user }),
        setVersionUrl: (versionUrl) => set({ versionUrl }),
        setVersionApp: (versionApp) => set({ versionApp }),
        setMetaPorQuantidade: (metaPorQuantidade) => set({ metaPorQuantidade }),
        clearAll: () =>
          set(() => ({
            user: undefined,
            token: undefined,
            versionUrl: undefined,
            versionApp: undefined,
            nivelAcesso: 1,
          })),
        setNivelAcesso: (nivelAcesso) => set({ nivelAcesso: nivelAcesso ?? 1 }),
      },
    }),
    {
      name: 'auth',
      partialize: (state) => ({
        token: state.token,
        user: state.user,
        versionUrl: state.versionUrl,
        versionApp: state.versionApp,
        chaveMaps: state.chaveMaps,
				metaPorQuantidade: state.metaPorQuantidade,
				nivelAcesso: state.nivelAcesso,
      }),
    },
  ),
)
